var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.minute)+":"+_vm._s(_vm.second))])])}
var staticRenderFns = []

export { render, staticRenderFns }